import { FileType } from '../common';

export const enum AIToolkitOptions {
  TITLE_OPTIMIZATION = 'title-optimization',
}

export const enum ViewGptJobOptions {
  DETAILS = 'details',
  TASKS = 'tasks',
}

export interface IGptTask {
  created: string;
  createdBy: string;
  lastModified: string;
  lastModifiedBy: string;
  isDeleted: boolean;
  id: string;
  gptJobId: string;
  gptState: {
    value: string;
  };
  lastMessage: string;
  itemsCount: null | number;
  itemsSuccessfull: null | number;
  tokensUsed: null | number;
}

export interface IMyGptJob {
  id: string;
  customerId: string;
  fileFormat: {
    value: string;
  };
  isActive: boolean;
  name: string;
  feedUrl: string;
  titleColumnName: string;
  idColumnName: string;
  xmlNodeName: string;
  outputFileUrl: string;
  inputLanguage: string;
  outputLanguage: string;
  virtualColumns: Array<string>;
  columnsToCompound: Array<string>;
  gptTasks: Array<IGptTask>;
}

export type IGetMyGptJobsResponseData = Array<IMyGptJob>;

export interface IEditMyGptJobRequestData {
  gptJobId: string;
  body: Pick<IMyGptJob, 'isActive'>;
}

export type IGetGptJobDetailsResponseData = IMyGptJob;

export interface IGptJobItemProps {
  icon: JSX.Element;
  title: string;
  content:
    | JSX.Element
    | string
    | Array<{ text: string; key: string }>
    | undefined;
  isVisible: boolean;
}

export type IGptJobCardItemProps = Omit<IGptJobItemProps, 'isVisible'>;

export interface IAnalyzeFeedRequestData {
  feedLink: string;
  documentType: FileType;
}

export interface IAnalyzeFeedResponseData {
  success: boolean;
  errorMessage: string;
  csvColumns: Array<string> | null;
  xmlTags: Array<{
    localeName: string;
    fullName: string;
    attribute: string;
  }> | null;
}

export interface ICreateGptJobRequestData {
  feedLink: string;
  idPropertyName: string;
  xmlNodeName: string | null;
  titlePropertyName: string;
  columnNamesToAdd: Array<string>;
  virtualColumnsToAdd: Array<string>;
  languageNameToTranslate: string;
  documentOriginalLanguage: string;
  documentName: string;
  documentReadFormat: string;
  documentWriteFormat: string;
}

export interface ICreateGptJobResponseData {
  gptJobId: string;
  success: boolean;
  errorMessage: string;
}

export interface ICreateGptJobTitlePreviewRequestData
  extends Omit<ICreateGptJobRequestData, 'documentOriginalLanguage'> {
  amountToTake: number;
  originalLanguageName: string;
}

export interface IGptJobTitlePreview {
  originalTitle: string;
  optimisedTitle: string;
  titleId: string;
}

export interface ICreateGptJobTitlePreviewResponseData {
  success: boolean;
  errorMessage: string;
  titles: Array<IGptJobTitlePreview>;
}
